enum MarketTradeType {
  buy = 'buy',
  sell = 'sell',
  crowdFunding = 'crowd_funding',
}

enum MarketOrderType {
  marketOrder = 'market_order',
  limitOrder = 'limit_order',
}

enum IbdaxPortalLocale {
  ar = 'ar',
  en = 'en',
}

export { MarketTradeType, MarketOrderType, IbdaxPortalLocale };
